<ng-container *ngIf="row">
  <!-- TODO: add confirm done here -->
  <elm-prepopulated-state-machine
    type="center"
    [row]="row"
    [form]="form$ | async"
    [formData]="formData$ | async"
    [state]="formState$ | async"
    [prepopulatedData]="prepopulatedData$ | async"
    [user]="user$ | async"
    (paymentDone)="paymentDone()"
    (prepopulatedSubmit)="prepopulatedSubmit($event)"
    (prepopulatedEdit)="prepopulatedEdit($event)"
    (userVerified)="userVerified($event)"
  >
  </elm-prepopulated-state-machine>
</ng-container>
